import { FeatureCategory } from '../types';

export const proLevelCareToolsFeatures: FeatureCategory = {
  name: "Pro-Level Care Tools",
  icon: "Clipboard",
  features: [
    { 
      name: "Visits & Scheduling", 
      description: "Track care visits with check-in/check-out times, schedule future visits, and maintain visit history.",
      starter: "—", max: "—", family: "👁", familyPlus: "✔", careAddOn: "✔"
    },
    { 
      name: "Care Notes & Documentation", 
      description: "Create detailed care notes during or after visits, with templates and easy sharing capabilities.",
      starter: "—", max: "—", family: "👁", familyPlus: "✔", careAddOn: "✔"
    },
    { 
      name: "Task Execution", 
      description: "Professional task management system for organizing care activities and workflow coordination.",
      starter: "—", max: "—", family: "👁", familyPlus: "✔", careAddOn: "✔"
    },
    { 
      name: "Medication Logging (Care Context)", 
      description: "Log medication administration with time stamps, dosages, and any observed reactions.",
      starter: "—", max: "—", family: "👁", familyPlus: "✔", careAddOn: "✔"
    },
    { 
      name: "Incident & Fall Reporting", 
      description: "Log and track incidents, accidents, or concerns with detailed documentation for safety records.",
      starter: "—", max: "—", family: "👁", familyPlus: "✔", careAddOn: "✔"
    },
    { 
      name: "Session / Shift Tracking", 
      description: "Track care sessions and shifts with detailed time logs and activity summaries.",
      starter: "—", max: "—", family: "👁", familyPlus: "✔", careAddOn: "✔"
    },
    { 
      name: "Voice Notes → Actions", 
      description: "Convert voice commands and notes into actionable tasks, reminders, and care plan updates.",
      starter: "—", max: "—", family: "👁", familyPlus: "✔", careAddOn: "✔"
    },
    { 
      name: "Supply Requests", 
      description: "Manage and track medical supply requests, inventory, and procurement.",
      starter: "—", max: "—", family: "👁", familyPlus: "✔", careAddOn: "✔"
    },
    { 
      name: "Care Updates & Handoffs", 
      description: "Dedicated hub for communicating care updates, sharing reports, and coordinating handoffs.",
      starter: "—", max: "—", family: "👁", familyPlus: "✔", careAddOn: "✔"
    },
    { 
      name: "Condition-Specific Care Packs", 
      description: "Toggle care packs to customize observation checklists and insights: Dementia & Cognitive Change, Diabetes, Heart Health & Heart Failure, COPD & Chronic Lung Disease, Post Stroke & Neurologic, Mobility/Falls & Osteoporosis, Depression/Loneliness & Mood, Cancer & Treatment, Nutrition & Hydration, Urinary Health & UTI Risk, Parkinson's & Neuromuscular, Arthritis & Chronic Pain, Recovery Post Hospital/Surgery.",
      starter: "—", max: "—", family: "—", familyPlus: "✔", careAddOn: "✔"
    },
    { 
      name: "Self-Care Reminders", 
      description: "Personalized reminders and prompts to help caregivers prioritize their own well-being while providing care.",
      starter: "—", max: "—", family: "—", familyPlus: "✔", careAddOn: "✔"
    }
  ]
};
